/* LinkAndSyncAction.js */

"use strict";

const LinkAndSyncDetailComponent = require("./veils/linkandsyncdetail/LinkAndSyncDetailComponent");
const LinkAndSyncSummaryComponent = require("./veils/linkandsyncsummary/LinkAndSyncSummaryComponent");
const _ = require("lodash");

class LinkAndSyncAction {
    constructor(
        logger,
        gameEditor,
        modalUserFeedback,
        DeviceEntity,
        userSession,
        activeView,
        DataSyncConfig
    ) {
        this._logger = logger;
        this._gameEditor = gameEditor;
        this._deviceEntity = DeviceEntity;
        this._modalUserFeedback = modalUserFeedback;
        this._activeView = activeView;
        this._selectedDeviceIds = _.get(this._activeView, "pagingFeed", {})
            ? this._activeView.getSelectedDeviceIds().selectedRows || []
            : [];

        this.userSession = userSession;
        this._dataSyncConfig = DataSyncConfig;
        this._dataSyncServiceNow = {};
        this._dataSyncNetbox = {};
        this._dataSyncXd = {};
        this.run = this.run.bind(this);
        this._runLinkAndSyncDevices = this._runLinkAndSyncDevices.bind(this);
    }

    async run() {
        if (this._selectedDeviceIds.length) {
            try {
                //let's get ci data
                this._dataSyncServiceNow = this._gameEditor._dataSyncConfigEntity.serviceNow;
                this._dataSyncNetbox = this._gameEditor._dataSyncConfigEntity.netBox;
                this._dataSyncXd = this._gameEditor._dataSyncConfigEntity.xDome;
                await this._activeView.pagingFeed.waitForRangeIdsUpdated();

                this._orderedSync = await this._modalUserFeedback.displayCustom(
                    new LinkAndSyncDetailComponent(this._logger, this),
                    {
                        dontHide: true,
                    }
                );

                this._modalUserFeedback.displayLoading();
                await this._runLinkAndSyncDevices();
            } catch (err) {
                if (err && err.userRejected) {
                    this._logger.warn({error: err}, "Link And Sync action - User Canceled");
                    this._modalUserFeedback.hideDisplayed();
                } else {
                    this._logger.warn({error: err}, "Link And Sync action - Error");
                    await this._modalUserFeedback.displayError(err);
                }
            }
        } else {
            return Promise.resolve();
        }
    }

    async _getProvider(providerName, providerProduct) {
        return await this._dataSyncConfig.loadProviderConfig(
            this.userSession.activeOrganization.id,
            providerName,
            providerProduct
        );
    }

    async _runLinkAndSyncDevices() {
        try {
            const workInput = {
                dataProviderProduct: "cmdb",
                syncOptions: {preview: false},
            };

            let schedName = "";
            let schedDescription = "Sync data between selected Gluware devices ";

            //determine both or singular data provider
            if (
                this._orderedSync.serviceNow &&
                this._orderedSync.netBox &&
                this._orderedSync.xDome
            ) {
                schedName += "ServiceNow, NetBox and Claroty xDome";
                schedDescription += "ServiceNow, NetBox and Claroty xDome";
                workInput.multiSync = [
                    {dataProvider: "serviceNow", dataProviderProduct: "cmdb"},
                    {
                        dataProvider: "netBox",
                        dataProviderProduct: "cmdb",
                        syncAll: this._orderedSync.allDevices || false,
                    },
                    {
                        dataProvider: "claroty",
                        dataProviderProduct: "xdome",
                    },
                ];
            } else if (this._orderedSync.serviceNow) {
                schedName += "ServiceNow";
                schedDescription += "and ServiceNow";
                workInput.dataProvider = "serviceNow";
            } else if (this._orderedSync.netBox) {
                schedName += "NetBox";
                schedDescription += "and NetBox";
                workInput.dataProvider = "netBox";
                workInput.syncAll = this._orderedSync.allDevices || false;
            } else if (this._orderedSync.xDome) {
                schedName += "Claroty xDome";
                schedDescription += "and Claroty xDome";
                workInput.dataProvider = "claroty";
                workInput.dataProviderProduct = "xdome";
            }

            schedName += " Sync from Device Manager";

            /*
            const workType =
                this._orderedSync.serviceNow && this._orderedSync.netBox
                    ? "runMultiSyncWork"
                    : "runDataSyncWork";

             */
            const workTarget = {
                category: "entity",
                entityType: "Device",
                method: "multi",
                ids: this._selectedDeviceIds,
            };

            let now = new Date();
            //set a buffer time slightly ahead
            now.setMinutes(now.getMinutes() + 1);
            const schedule = {
                type: "one",
                tz: Intl.DateTimeFormat().resolvedOptions().timeZone,
                on: {
                    year: now.getFullYear(),
                    month: now.getMonth(),
                    date: now.getDate(),
                    hour: now.getHours(),
                    minute: now.getMinutes(),
                },
            };

            const result = await Promise.race([
                this._deviceEntity.scheduleDataSyncWork(
                    this.userSession.activeOrganization.id,
                    schedName,
                    schedDescription,
                    schedule,
                    workTarget,
                    workInput
                ),
                /*
                this._deviceEntity[workType](
                    this.userSession.activeOrganization.id,
                    workTarget,
                    workInput,
                    {launchAndForget: false},
                    progressCallBack
                ),
                this._showProgressVeil(),
                 */
            ]);

            if (result.closed || result.type === "schedule") {
                return this._modalUserFeedback.hideDisplayed();
            }

            if (result.errorMsg) {
                const err = new Error(result.errorMsg);
                err.errorCode = "CaptureError";
                err.errorMsg = result.errorMsg;
                throw err;
            }

            return this._modalUserFeedback.displayCustom(
                new LinkAndSyncSummaryComponent(result, this._logger)
            );
        } catch (err) {
            if (err.userRejected || err.closed) {
                this._logger.warn({error: err}, "ImportAction.run() - User Canceled.");
                return this._modalUserFeedback.hideDisplayed();
            } else {
                this._logger.warn({error: err}, "ImportAction.run() - Error");
                await this._modalUserFeedback.displayError(err);
            }
        }
    }
}

module.exports = LinkAndSyncAction;

LinkAndSyncAction.$inject = [
    "$teve.logger",
    "gameEditor.gameEditor",
    "$teve.ui.userFeedback",
    "$teve.entities.Device",
    "$teve.userSession",
    "gameEditor.activeView",
    "$teve.entities.DataSyncConfig",
];

LinkAndSyncAction.$displayDetails = {
    type: "Action",
    name: "LinkAndSyncAction",
    icon: "common.linkandsync",
    title: "Sync devices",
    shown: true,
    order: 9,
};
